import React from "react";
import { useForm, Controller } from "react-hook-form";

import Modal, {
  ModalTitle,
  ModalContent,
  ModalActions,
} from "lib/components/Modal";
import Select from "lib/components/Select";
import Stack from "lib/components/Stack";
import Button from "lib/components/Button";
import TextField from "lib/components/TextField";
import useIsResMobile from "lib/hooks/useIsResMobile";
import { useTheme } from "@material-ui/core";

interface ReportModalProps {
  open: boolean;
  onSubmit: (data: { title: string; contents: string }) => Promise<void>;
  onClose: () => void;
}

const ReportModal: React.FC<ReportModalProps> = ({
  open,
  onSubmit,
  onClose,
}) => {
  const isResMobile = useIsResMobile();
  const { breakpoints } = useTheme();
  const { control, errors, formState, handleSubmit } = useForm<{
    title: string;
    contents: string;
  }>({
    defaultValues: {
      title: "Inappropriate content",
      contents: "",
    },
  });

  const handleOnSubmit = handleSubmit(
    async (data: { title: string; contents: string }) => {
      try {
        await onSubmit(data);
        onClose();
      } catch (e) {
        console.log(e);
      }
    },
  );

  return (
    <Modal open={open} onClose={onClose} fullScreen={isResMobile}>
      <ModalTitle onClose={onClose}>Report</ModalTitle>

      <ModalContent>
        <form onSubmit={handleOnSubmit}>
          <Stack spacing="20px">
            <Controller
              as={Select}
              control={control}
              value=""
              rules={{ required: true }}
              name="title"
              placeholder="Choose your consultation area"
              defaultValue="Others"
              options={[
                {
                  key: "Inappropriate content",
                  value: "Inappropriate content",
                  label: "Inappropriate content",
                },
                {
                  key: "Spam/advertising",
                  value: "Spam/advertising",
                  label: "Spam/advertising",
                },
                {
                  key: "Others",
                  value: "Others",
                  label: "Others",
                },
              ]}
              withSearch={false}
              error={!!errors.title}
              helperText={errors.title?.message}
              onChange={() => {
                // noop
              }}
            />
            <Controller
              as={TextField}
              control={control}
              name="contents"
              type="text"
              placeholder="Please write down the reason for reporting"
              multiline
              minRows={7}
              maxRows={7}
              fullWidth
              rules={{ required: true }}
              error={!!errors.contents}
              helperText={errors.contents?.message}
            />
          </Stack>
        </form>
      </ModalContent>
      <ModalActions>
        <div
          css={`
            width: 160px;
            ${breakpoints.down("sm")} {
              width: 100%;
            }
          `}
        >
          <Button
            type="submit"
            disabled={formState.isSubmitting}
            round
            onClick={handleOnSubmit}
          >
            Report
          </Button>
        </div>
      </ModalActions>
    </Modal>
  );
};

export default ReportModal;
